import styled from 'styled-components';
import {
  SectionParent,
  BlueButton,
} from '../../../components/StyledComponents';
import React from 'react';
// import YourAppYourDevicesMobile from '../../../assets/v2/homepage/Andi_heroimage_mobile.svg';
import { navigate, graphql, StaticQuery } from 'gatsby';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import Image from 'gatsby-image';

const ImgItem = styled(Image)`
  width: 120%;
  margin-left: -10%;
  margin-top: 6rem;
  @media (max-width: 768px) {
    margin-top: 0rem;
    width: 100%;
    margin-left: 0rem;
  }
  @media (max-width: 520px) {
    width: 110%;
    margin-left: -10%;
    /* display: none; */
  }
`;

const ImgItemMobile = styled(LazyLoadImage)`
  display: none;
  @media (max-width: 520px) {
    width: calc(100% + 2rem);
    margin-left: -1rem;
    display: unset;
  }
`;

const SectionOne = styled(SectionParent)`
  margin-top: 6rem !important;
  padding-bottom: 6rem !important;
  background-color: #f9fbfe;
  min-height: calc(100vh - 6rem);
  @media (max-width: 768px) {
    padding-top: 5rem !important;
  }
  @media (max-width: 520px) {
    padding-top: 2rem !important;
  }
  width: 100%;
  display: grid;
`;

const SectionItemContainer = styled.div`
  grid-template-columns: repeat(24, 1fr);
  display: grid;
`;

export const Title = styled.h1`
  font-family: 'Nunito Sans', sans-serif;
  font-size: 48px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.21;
  letter-spacing: normal;
  color: #151828;
  @media (max-width: 1024px) {
    font-size: 36px;
  }
  @media (max-width: 520px) {
    font-size: 28px;
  }
`;
export const SectionOneTitle = styled(Title)`
  @media (max-width: 768px) {
    text-align: center;
  }
  @media (max-width: 520px) {
    text-align: center;
  }
`;

const GridLeft = styled.div`
  grid-column: span 11;
  /* padding-left: 3rem; */
  /* margin-top: 3rem; */
  align-content: center;
  display: grid;
  @media (max-width: 768px) {
    grid-column: span 24;
    padding-right: 0rem;
    margin-top: 0rem;
    margin-bottom: 3rem;
    padding-left: 0rem;
    min-height: 15rem;
  }
`;
const GridRight = styled.div`
  grid-column: span 13;
  display: grid;
  @media (max-width: 768px) {
    grid-column: span 24;
  }
`;

const HeroSubTitle = styled.div`
  padding-top: 2rem;
  font-family: 'Nunito Sans', sans-serif;
  font-size: 21px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.52;
  letter-spacing: normal;
  max-width: 28em;
  color: #626679;
  @media (max-width: 768px) {
    text-align: center;
  }

  @media (max-width: 520px) {
    text-align: center;
    padding-top: 0.5rem;
    margin-bottom: -1rem;
  }
`;
const BlueButtonWrapper = styled.div`
  margin-left: -10px;
  margin-top: 24px;
  button {
    border-radius: 8rem;
  }
  @media (max-width: 768px) {
    text-align: center;
  }
  @media (max-width: 520px) {
    justify-self: center;
  }
`;
const Announcement = styled.a`
  display: inline-flex;
  -webkit-box-align: center;
  align-items: center;
  justify-self: left;
  text-decoration: none;
  background: rgb(245, 246, 249);
  padding: 0.25rem 0.45rem;
  border-radius: 0.375rem;
  transition: all 0.07s ease 0s;
  :hover {
    box-shadow: rgb(222, 223, 227) 0px 0px 0px 1px inset;
  }

  @media (max-width: 768px) {
    justify-self: center;
  }
`;
const AnnouncementDiv = styled.div`
  display: inline-flex;
  -webkit-box-align: center;
  align-items: center;
  height: calc(1.375rem);
  background: #7b5fc2;
  border-radius: 0.25rem;
  padding: 0px 0.375rem;
  span {
    font-weight: 600;
    font-size: 0.75em;
    letter-spacing: 0em;
    line-height: 1.42rem;
    white-space: nowrap;
    text-overflow: ellipsis;
    color: rgb(255, 255, 255);
    overflow: hidden;
  }
`;

const AnnouncementText = styled.span`
  color: rgb(62, 63, 65);
  letter-spacing: 0em;
  margin-left: 0.75rem;
  line-height: 1.42rem;
  margin-right: 0.375rem;
  display: block;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
`;

const Arrow = styled.svg`
  height: 24px;
  width: 24px;
`;

export default () => (
  <div style={{ zIndex: 1, position: 'relative', background: '#f9fbfe' }}>
    <SectionOne>
      <SectionItemContainer>
        <GridLeft>
          <Announcement
            target="_blank"
            rel="noopener noreferrer"
            href="https://blog.esper.io/esper-funding-2020/"
          >
            <AnnouncementDiv>
              <span>New</span>
            </AnnouncementDiv>
            <AnnouncementText>Announcing our $7.6M Series A</AnnouncementText>
            <Arrow
              rotate="0"
              color="eventHorizon"
              preserveAspectRatio="xMidYMid meet"
              viewBox="0 0 24 24"
            >
              <path
                d="M13.509 8.259A.884.884 0 0 0 12.884 8c-.788 0-1.182.952-.625 1.509L13.75 11H8a1 1 0 1 0 0 2h5.75l-1.491 1.491c-.557.557-.163 1.509.625 1.509.234 0 .46-.093.625-.259l3.034-3.034a1 1 0 0 0 0-1.414l-3.034-3.034z"
                fill="currentColor"
              />
            </Arrow>
          </Announcement>
          <SectionOneTitle>
            Think Beyond
            <br />
            Managing Devices
          </SectionOneTitle>
          <HeroSubTitle style={{ paddingTop: '1rem' }}>
            Esper is the industry’s most powerful platform for Android device
            deployment and application management.
          </HeroSubTitle>
          <BlueButtonWrapper>
            <BlueButton
              id="homepage__get_started"
              onClick={() => navigate('/signup')}
            >
              Get started
            </BlueButton>
          </BlueButtonWrapper>
        </GridLeft>
        <GridRight>
          <StaticQuery
            query={graphql`
              query {
                file(relativePath: { eq: "v2/homepage/homepageHero2@3x.png" }) {
                  childImageSharp {
                    fluid(
                      quality: 90
                      traceSVG: { color: "#e0e4e9", threshold: 75 }
                    ) {
                      aspectRatio
                      src
                      srcSet
                      sizes
                      srcWebp
                      srcSetWebp
                      tracedSVG
                    }
                  }
                }
              }
            `}
            render={(data: any) => (
              <div style={{ alignSelf: 'center' }}>
                <ImgItem
                  fluid={data.file.childImageSharp.fluid}
                  alt="Think Beyond Managing Devices"
                  loading="lazy"
                />
              </div>
            )}
          />

          {/* <ImgItemMobile alt="Esper Andi" src={YourAppYourDevicesMobile} /> */}
        </GridRight>
      </SectionItemContainer>
    </SectionOne>
  </div>
);
